import React, { CSSProperties } from 'react';

import GameModal, { dangerBtnStyle, primaryBtnStyle } from 'components/GameModal/GameModal';

type PropType = {
  confirmationAnswer: (confirmation: any) => void;
  /**
   * Dismiss without answering. A dismiss is NOT a third answer: no check, no
   * fold, nothing sent to the server. The player is simply returned to the
   * action bar with their turn exactly as it was, and acts again deliberately.
   */
  onClose: () => void;
};

// Mirrors the FoldAction switch: 2 = Check (the free, recommended action),
// 1 = Fold Anyway (the destructive choice).
const ANSWER_CHECK = 2;
const ANSWER_FOLD = 1;

function FoldConfirmationModal({ confirmationAnswer, onClose }: PropType) {
  const confirmAnswer = (answer: any) => {
    confirmationAnswer(answer);
  };

  return (
    // Use the shared branded GameModal (dark card + animated glow border) so
    // this confirm matches the tournament / pause / cashier modals instead of
    // the old one-off MUI dialog.
    //
    // Tapping outside dismisses (EN-10789). That is not a third answer: the
    // turn is untouched and still live, the action bar is right there, and the
    // player acts again when they mean to. Still no close X — the two buttons
    // and the scrim are the whole affordance.
    <GameModal open showClose={false} maxWidth='360px' onClose={onClose}>
      <div style={contentStyle}>
        <div style={titleStyle}>{`Hey partner, you sure? It's free to check!`}</div>
        <div style={buttonColumnStyle}>
          {/* Check is the safe/recommended action → primary. Fold Anyway is
              destructive → danger red. */}
          <button
            style={{ ...primaryBtnStyle, flex: '0 0 auto', width: '100%' }}
            onClick={() => confirmAnswer(ANSWER_CHECK)}>
            Check
          </button>
          <button
            style={{ ...dangerBtnStyle, flex: '0 0 auto', width: '100%' }}
            onClick={() => confirmAnswer(ANSWER_FOLD)}>
            Fold Anyway
          </button>
        </div>
      </div>
    </GameModal>
  );
}

export default FoldConfirmationModal;

const contentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.25rem',
  textAlign: 'center'
};

const titleStyle: CSSProperties = {
  fontSize: '1rem',
  fontWeight: 700,
  color: '#ffffff',
  lineHeight: 1.35
};

const buttonColumnStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.6rem',
  width: '100%'
};
